export default __webpack_public_path__ + "static/bg-tablet-a9c1f577808a90d534254c00edd7907e.webp";